import { getCrs } from "@evergis/react";
import { Crs, webMercator } from "@evergis/sgis/es/Crs";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useProjectSrid } from "../../ducks/project/hooks";
import { getClientData } from "../../ducks/project/selectors";
import { getProj4Representation } from "../../resources/spatialReferences";

export function useProjectCrs(): Crs {
  const projectSrid = useProjectSrid();
  const clientData = useSelector(getClientData);
  const authName = clientData?.crsAuthName || "EPSG";
  const sgisCrs = getCrs(projectSrid);
  const { data: proj4Representation } = getProj4Representation.use({
    input: projectSrid && !sgisCrs ? `${authName}:${projectSrid}` : void 0,
    waitInput: true,
  });

  return useMemo(() => {
    if (!projectSrid) {
      return webMercator;
    }

    if (sgisCrs) {
      return sgisCrs;
    }

    return proj4Representation
      ? new Crs({
          wkid: projectSrid,
          proj4Representation,
        })
      : void 0;
  }, [projectSrid, proj4Representation, sgisCrs]);
}
